<template>
  <el-dialog
    :visible.sync="dialogFormVisible"
    width="700px"
    :before-close="close"
    :title="titles[updateType]"
  >
    <el-table
      :data="detailList1"
      border
      prop="name"
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column prop="name" label="修改日志记录"> </el-table-column>

      <el-table-column prop="data"> </el-table-column>
    </el-table>
    <br /><br />
    <el-table
      :data="detailList2"
      border
      prop="name"
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column prop="name" label="操作"> </el-table-column>

      <el-table-column prop="data"> </el-table-column>
    </el-table>
    <br /><br />
    <el-table
      :data="datailList3"
      border
      prop="name"
      style="width: 100%"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column prop="name" label="修改字段"> </el-table-column>
      <el-table-column prop="from" label="修改前"> </el-table-column>
      <el-table-column prop="to" label="修改后"> </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      titles: {
        detail: "日志详情"
      },
      checkList: [],
      detailList1: [
        { name: "CREATED", data: this.initForm.created },
        { name: "操作人", data: this.initForm.actor },
        { name: "操作接口", data: this.initForm.menu },
        { name: "URL", data: this.initForm.http_url },
        { name: "HTTP方法", data: this.initForm.http_method },
        { name: "用户IP", data: this.initForm.remote_addr }
      ],
      detailList2: [
        { name: "操作", data: this.initForm.action },
        { name: "内容类型", data: this.initForm.content_type },
        { name: "操作对象", data: this.initForm.content_obj }
      ],
      datailList3: []
    };
  },
  mounted() {
    const arr = JSON.parse(this.initForm.changesName || "{}");
    for (let i in arr) {
      this.datailList3.push({
        name: i,
        from: arr[i][0],
        to: arr[i][1]
      });
    }
  },
  computed: {
    departmentGroup() {
      let departmentGroup = this.$store.state.departmentGroup;
      return departmentGroup;
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.updateType === "edit") {
          let url = "structures/" + this.initForm.id + "/";
          this.$http["put"](url, this.initForm, () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          });
        } else {
          let url = "structures/";
          this.$http["post"](url, this.initForm, () => {
            this.$baseNotice.message("新增成功");
            this.$emit("close");
            this.$emit("update");
          });
        }
      });
    }
  }
};
</script>
